export const handleGuestBookingConflict = (
    {
      inHouseAndDueInConflict,
      multipleInHouseConflict,
      multipleDueInConfict,
      multipleAccompanyLastnameFound,
      isConfirmationNumberRequired
    },
    setShowCustomPopup,
    guestBookingHandler,
    guestBookFormData,
    t
  ) => {
    const hasConfirmationNumber = Boolean(guestBookFormData.get("confirmationNumber"));

    if (inHouseAndDueInConflict) {
      setShowCustomPopup(true, {
        htmlTagId: "inHouseAndDueInConflict",
        heading: t("check_in.checkin_conflict.inHouseAndDueInConflict.heading"),
        subHeading: t("check_in.checkin_conflict.inHouseAndDueInConflict.subHeading"),
        primaryButtonText: t("check_in.checkin_conflict.inHouseAndDueInConflict.primaryButtonText"),
        secondaryButtonText: t("check_in.checkin_conflict.inHouseAndDueInConflict.secondaryButtonText"),
        secondaryButtonStyleIsUnderline: false,
        primaryOnClick: () => {
          setShowCustomPopup(false, {});
          guestBookFormData.delete("flowIntent");
          guestBookFormData.append("flowIntent", "checkin");
          if (multipleDueInConfict) {
            handleMultipleDueInConflictModal(setShowCustomPopup, guestBookFormData, guestBookingHandler, t);
          } else {
            guestBookingHandler("", "", "", "bookingDataEnquiry");
          }
        },
        secondaryOnClick: () => {
          setShowCustomPopup(false, {});
          guestBookFormData.delete("flowIntent");
          guestBookFormData.append("flowIntent", "login");
          if (multipleInHouseConflict) {
            handleMultipleInHouseConflictModal(setShowCustomPopup, guestBookFormData, guestBookingHandler, t);
          } else {
            guestBookingHandler("", "", "", "bookingDataEnquiry");
          }
        },
        closeOnClick: () => {setShowCustomPopup(false, {}); guestBookFormData.delete("flowIntent");}
      });
    } else if (multipleDueInConfict) {
      guestBookFormData.delete("flowIntent");
      guestBookFormData.append("flowIntent", "checkin");
      handleMultipleDueInConflictModal(setShowCustomPopup, guestBookFormData, guestBookingHandler, t);
    } else if (multipleInHouseConflict) {
      guestBookFormData.delete("flowIntent");
      guestBookFormData.append("flowIntent", "login");
      handleMultipleInHouseConflictModal(setShowCustomPopup, guestBookFormData, guestBookingHandler, t);
    } else if (multipleAccompanyLastnameFound) {
      if (isConfirmationNumberRequired && !hasConfirmationNumber) {
        handleMultipleAccompanyConfirmationModal(setShowCustomPopup, guestBookFormData, guestBookingHandler, t);
      } else {
        handleMultipleAccompanyFirstnameModal(setShowCustomPopup, guestBookFormData, guestBookingHandler, t);
      }
    }
  };
  
  const handleMultipleDueInConflictModal = (setShowCustomPopup, guestBookFormData, guestBookingHandler, t) => {
    setShowCustomPopup(true, {
      htmlTagId: "multipleDueInConfict",
      heading: t("check_in.checkin_conflict.multipleDueInConflict.heading"),
      subHeading: t("check_in.checkin_conflict.multipleDueInConflict.subHeading"),
      primaryButtonText: t("check_in.checkin_conflict.multipleDueInConflict.primaryButtonText"),
      showInput: true,
      inputLabel: t("check_in.checkin_conflict.multipleDueInConflict.inputLabel"),
      inputMode: "text",
      primaryOnClick: true,
      onSubmitCallback: (inputValue) => {
        guestBookFormData.delete("confirmationNumber");
        guestBookFormData.append("confirmationNumber", inputValue);
        guestBookingHandler("", "", "", "bookingDataEnquiry", true);
        setShowCustomPopup(false, {})
      },
      closeOnClick: () => {setShowCustomPopup(false, {}); guestBookFormData.delete("flowIntent");}
    });
  };
  
  const handleMultipleInHouseConflictModal = (setShowCustomPopup, guestBookFormData, guestBookingHandler, t) => {
    setShowCustomPopup(true, {
      htmlTagId: "multipleInHouseConflict",
      heading: t("check_in.checkin_conflict.multipleInHouseConflict.heading"),
      subHeading: t("check_in.checkin_conflict.multipleInHouseConflict.subHeading"),
      primaryButtonText: t("check_in.checkin_conflict.multipleInHouseConflict.primaryButtonText"),
      showInput: true,
      inputLabel: t("check_in.checkin_conflict.multipleInHouseConflict.inputLabel"),
      primaryOnClick: true,
      onSubmitCallback: (inputValue) => {
        guestBookFormData.delete("roomNumber");
        guestBookFormData.append("roomNumber", inputValue);
        guestBookingHandler("", "", "", "bookingDataEnquiry");
        setShowCustomPopup(false, {})
      },
      closeOnClick: () => {setShowCustomPopup(false, {}); guestBookFormData.delete("flowIntent");}
    });
  };

  const handleMultipleAccompanyConfirmationModal = (setShowCustomPopup, guestBookFormData, guestBookingHandler, t) => {
    setShowCustomPopup(true, {
      htmlTagId: "multipleAccompanyConfirmationConflict",
      heading: t("check_in.checkin_conflict.multipleAccompanyConfirmationConflict.heading"),
      subHeading: t("check_in.checkin_conflict.multipleAccompanyConfirmationConflict.subHeading"),
      primaryButtonText: t("check_in.checkin_conflict.multipleAccompanyConfirmationConflict.primaryButtonText"),
      showInput: true,
      inputLabel: t("check_in.checkin_conflict.multipleAccompanyConfirmationConflict.inputLabel"),
      inputMode: "text",
      primaryOnClick: true,
      onSubmitCallback: (inputValue) => {
        guestBookFormData.delete("confirmationNumber");
        guestBookFormData.append("confirmationNumber", inputValue.trim());
        guestBookingHandler("", "", "", "bookingDataEnquiry", true);
        setShowCustomPopup(false, {});
      },
      closeOnClick: () => {
        setShowCustomPopup(false, {});
        guestBookFormData.delete("confirmationNumber");
        guestBookFormData.delete("firstName");
      }
    });
  };

  const handleMultipleAccompanyFirstnameModal = (setShowCustomPopup, guestBookFormData, guestBookingHandler, t) => {
    setShowCustomPopup(true, {
      htmlTagId: "multipleAccompanyFirstnameConflict",
      heading: t("check_in.checkin_conflict.multipleAccompanyFirstnameConflict.heading"),
      subHeading: t("check_in.checkin_conflict.multipleAccompanyFirstnameConflict.subHeading"),
      primaryButtonText: t("check_in.checkin_conflict.multipleAccompanyFirstnameConflict.primaryButtonText"),
      showInput: true,
      inputLabel: t("check_in.checkin_conflict.multipleAccompanyFirstnameConflict.inputLabel"),
      inputMode: "text",
      primaryOnClick: true,
      onSubmitCallback: (inputValue) => {
        guestBookFormData.delete("firstName");
        guestBookFormData.append("firstName", inputValue.trim());
        guestBookingHandler("", "", "", "bookingDataEnquiry", true);
        setShowCustomPopup(false, {});
      },
      closeOnClick: () => {
        setShowCustomPopup(false, {});
        guestBookFormData.delete("firstName");
      }
    });
  };
  


  export const cardValidationIntermediaryEvents = {
    LANDED_ON_CARD_DETAILS_PAGE:"LANDED_ON_CARD_DETAILS_PAGE",

    REGISTER_API_SUCCESS : "REGISTER_API_SUCCESS",
    REGISTER_API_FAILED : "REGISTER_API_FAILED",

    GOT_PAYMENT_GATEWAY_RESPONSE : "GOT_PAYMENT_GATEWAY_RESPONSE",

    CHECKS_API_SUCCESS : "CHECKS_API_SUCCESS",
    CHECKS_API_FAILED : "CHECKS_API_FAILED",

    PAYMENT_GATEWAY_RESPONSE_APPROVED:"PAYMENT_GATEWAY_RESPONSE_APPROVED",
    PAYMENT_GATEWAY_RESPONSE_DECLINED:"PAYMENT_GATEWAY_RESPONSE_DECLINED",
    PAYMENT_GATEWAY_RESPONSE_CANCELLED:"PAYMENT_GATEWAY_RESPONSE_CANCELLED",
    PAYMENT_GATEWAY_RESPONSE_ERROR : "PAYMENT_GATEWAY_RESPONSE_ERROR",

    INTERNAL_CHECK_IF_SSL_RESULT_APPROVED_SUCCESS : "INTERNAL_CHECK_IF_SSL_RESULT_APPROVED_SUCCESS",
    INTERNAL_CHECK_IF_SSL_RESULT_APPROVED_FAILED: "INTERNAL_CHECK_IF_SSL_RESULT_APPROVED_FAILED",

    CARD_UPDATE_API_SUCCESS :"CARD_UPDATE_API_SUCCESS" ,
    CARD_UPDATE_API_FAILED : "CARD_UPDATE_API_FAILED"
  }

export const AvsCodes = {
    A: "Street address matches, ZIP does not",
    B: "Street address matches, but ZIP not verified",
    C: "Street address and ZIP not verified",
    D: "Street address and ZIP match (International Only)",
    E: "AVS data is invalid or AVS not allowed for this card type",
    F: "Street address and postal code match (UK Only)",
    G: "Non-U.S. issuing bank does not support AVS",
    I: "Address information not verified for international transaction",
    K: "Card member name matches",
    L: "Card member name and ZIP match ",
    M: "Street address and postal code match (International Only)",
    N: "Street address and ZIP code do not match",
    O: "No Response sent(Elavon)",
    P: "ZIP code matches, street address unverifiable (International Only)",
    R: "System unavailable, retry",
    S: "AVS not supported",
    T: "9-Digit ZIP matches, street address does not",
    U: "Address information unavailable",
    W: "9-Digit ZIP matches, street address does not",
    X: "9-Digit ZIP and street address match",
    Y: "5-Digit ZIP and street address match",
    Z: "5-Digit ZIP matches, street address does not"
  };
